/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import AccommodationTaxListView from '../../view/pages/accommodation_tax/ListView'
import LocalDate from '../../domain/type/Date'
import NProgress from 'nprogress'
import AccommodationTaxSearchStore from '../../store/accommodation_tax/AccommodationTaxSearchStore'
import MonthlyReportAction from '../../action/monthly_report'
import AccommodationTaxesStore from '../../store/accommodation_tax/AccommodationTaxesStore'
import SessionAction from '../../action/session'
import HotelOptionsStore from '../../store/options/HotelOptionsStore'
import ReservationStore from '../../store/accommodation_tax/ReservationStore'

class ListContainer extends Component {
  static getStores() {
    return [HotelOptionsStore, AccommodationTaxSearchStore, AccommodationTaxesStore, ReservationStore]
  }

  static calculateState(prevState, props) {
    return {
      option_hotels: HotelOptionsStore.getState(),
      search: AccommodationTaxSearchStore.getState(),
      accommodation_tax: AccommodationTaxesStore.getState(),
      reservation: ReservationStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()

    SessionAction.fetchUserHotels()

    const date = this.state.match.params.date
    const check_in_date = date ? LocalDate.parse(date) : LocalDate.today().beginningOfMonth()

    if (this.state.showDetail) {
      const accommodation_tax_id = this.state.match.params.id
      await MonthlyReportAction.fetchAccommodationTaxDetail(accommodation_tax_id)
    } else if (this.state.search.search_hotel_id) {
      await MonthlyReportAction.fetchAccommodationTaxByDate(check_in_date, this.state.search.search_hotel_id)
    }

    NProgress.done()
  }

  render() {
    return AccommodationTaxListView(this.state)
  }
}

export default withRouter(Container.create(ListContainer, { withProps: true }))
